import {apis as diariesAPIs} from './diaries/diaries';
import {apis as authAPIs} from './auth/auth';


const apis = {
  diaries: diariesAPIs,
  auth: authAPIs,
};


export default apis;
